import { concat, startsWith, assoc, set, lensProp, pipe } from 'ramda'

export default class UpsertDealService {
  constructor(vue) {
    this.vue = vue
  }

  async fetchEditModel(dealKey) {
    const url = concat('deals/foreditor', dealKey ? `/${dealKey}` : '')
    return await this.vue.$safeApiClient.get(url)
  }

  validateFetchResponse({ data }) {
    ;['deal', 'products', 'resources'].reduce((agg, next) => {
      if (!(next in data)) return agg.concat(`Response.data did not contain ${next}`)
    }, new Validation(data))
  }

  handleValidFetchResponse({ data }) {
    return {
      deal: data.deal,
      products: data.products,
      resources: data.resources,
    }
  }

  async save(deal, enableMultilanguage) {
    const saveModel = pipe(this.setProductCustomPrices, deal =>
      enableMultilanguage ? deal : set(lensProp('TranslationInfo'), null, deal),
    )(deal)
    return await this.vue.$apiClient.post(`deals/${saveModel.Key}`, saveModel)
  }

  setProductCustomPrices(deal) {
    if (typeof deal.Products === 'undefined') return
    Object.keys(deal.Products).forEach(productKey => {
      deal.Products[productKey].CustomPriceIncludesTax =
        deal.Products[productKey].CustomPriceType === null
          ? deal.Products[productKey].OriginalProductPriceIncludesTax
          : deal.Products[productKey].CustomPriceIncludesTax
    })
    return deal
  }
}

class Validation {
  constructor(x, errors) {
    this.x = x
    this.isValid = !(errors && errors.length)
    this.errors = errors
  }

  concat(error) {
    return new Validation(this.x, this.errors.concat(error))
  }

  map(f) {
    return new Validation(f(this.x), this.errors)
  }
}
